export default __webpack_public_path__ + "static/dynamic-compound-transitive-e5bb2a2d3664e5e7581f48fa21ba8015.svg";